(function () {
  'use strict';

  function init() {
    var source = document.querySelector('[data-lf-guide-media]');
    if (!source) return;

    var images = {
      interior: source.dataset.interior,
      exterior: source.dataset.exterior,
      professional: source.dataset.professional,
      advice: source.dataset.advice,
      led: source.dataset.led
    };
    var pageHandle = source.dataset.pageHandle || '';
    var pageTitle = source.dataset.pageTitle || 'Guide des luminaires';
    var pageImage = source.dataset.pageImage || '';
    var imagePrefix = source.dataset.guideImagePrefix || '';

    function familyFor(value) {
      var text = (value || '').toLocaleLowerCase();
      if (/led|ampoule|ruban|neon|panneau|dalle|reglette|réglett/.test(text)) return 'led';
      if (/exterieur|extérieur|terrasse|jardin|piscine|allee|allée|solaire|facade|façade|balcon|borne/.test(text)) return 'exterior';
      if (/profession|industri|sport|secours|erp|atelier|ip\d|norme|entrepot|entrepôt/.test(text)) return 'professional';
      if (/choisir|conseil|temperature|température|kelvin|lumens|dimension|hauteur|installation|sécurité|entretien|economie|économie/.test(text)) return 'advice';
      return 'interior';
    }

    function guideHandle(link) {
      if (!link) return '';
      if (link.dataset.guideHandle) return link.dataset.guideHandle;
      try {
        var path = new URL(link.href, window.location.origin).pathname.split('/').filter(Boolean);
        return path[0] === 'pages' ? path[1] || '' : '';
      } catch (error) { return ''; }
    }

    function guideImageUrl(handle) {
      if (!handle) return '';
      if (handle === 'ampoules-led') return 'https://cdn.shopify.com/s/files/1/1092/3288/2002/files/guide-ampoules-led-e27-e14-gu10-luminaire-france.png?v=1792275048';
      if (!imagePrefix) return '';
      return imagePrefix + 'lf-guide-thumb-' + handle + '.jpg';
    }

    function setImage(img, url, alt) {
      if (!img || !url) return;
      img.alt = alt || '';
      if (img.dataset.lfGuideOriginal === url) return;
      img.dataset.lfGuideOriginal = url;
      var picture = img.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function (item) {
          item.removeAttribute('srcset');
          item.removeAttribute('data-srcset');
          item.removeAttribute('data-src');
        });
      }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.removeAttribute('data-lazy-src');
      img.src = url;
      img.loading = img.closest('.lfg2-hero, .lf-guide-hero, .lf-piece-hero, .lf-ambiance-hero, .lf-eco-hero') ? 'eager' : 'lazy';
    }

    function refreshEditorialImages() {
      document.querySelectorAll('#MainContent .page-content rte-formatter img').forEach(function (img) {
        if (img.closest('.lf-guide-gallery')) return;
        var card = img.closest('a[href*="/pages/"]');
        var handle = guideHandle(card);
        var uniqueCardImage = guideImageUrl(handle);
        var url = uniqueCardImage || (pageHandle !== 'guide-des-luminaires' && pageImage) || images[familyFor(pageHandle + ' ' + pageTitle)];
        var alt = card ? 'Illustration du guide ' + card.textContent.trim() : 'Illustration originale du guide ' + pageTitle;
        setImage(img, url, alt);
        var wrapper = img.closest('figure, picture, .lf-guide-editorial-photo, .lfg2-hero figure');
        if (wrapper) wrapper.classList.add('lf-guide-media-ready');
      });
    }

    function marketingAllowed() {
      var allowed = false;
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy.marketingAllowed === 'function') allowed = !!privacy.marketingAllowed();
      } catch (error) {}
      try {
        var choice = JSON.parse(localStorage.getItem('lf_cookie_consent_v2') || 'null');
        return allowed || !!(choice && choice.marketing === true);
      } catch (error) { return allowed; }
    }

    function savedGuideInterest() {
      if (!marketingAllowed()) return '';
      try { return sessionStorage.getItem('lf_guide_interest_v1') || ''; }
      catch (error) { return ''; }
    }

    function ensureSpotlight(hub, groups) {
      if (hub.querySelector('[data-guide-spotlight]')) return;
      var guides = [];
      groups.forEach(function (group) {
        group.querySelectorAll('a[href*="/pages/"]').forEach(function (link) {
          var handle = guideHandle(link);
          if (handle && !guides.some(function (item) { return item.handle === handle; })) {
            guides.push({ handle: handle, title: link.textContent.trim(), url: link.href });
          }
        });
      });
      if (guides.length < 3) return;

      var interest = savedGuideInterest();
      var day = Math.floor(Date.now() / 604800000);
      var start = day % guides.length;
      var featured = [];
      if (interest) {
        var preferred = guides.find(function (item) { return item.handle === interest; });
        if (preferred) featured.push(preferred);
      }
      for (var offset = 0; offset < guides.length && featured.length < 3; offset++) {
        var candidate = guides[(start + offset) % guides.length];
        if (!featured.some(function (item) { return item.handle === candidate.handle; })) featured.push(candidate);
      }

      var section = document.createElement('section');
      section.className = 'lf-guide-directory__spotlight';
      section.dataset.guideSpotlight = 'true';
      section.setAttribute('aria-labelledby', 'lf-guide-spotlight-title');
      var heading = document.createElement('div');
      heading.className = 'lf-guide-directory__spotlight-heading';
      var copy = document.createElement('div');
      var title = document.createElement('h3');
      title.id = 'lf-guide-spotlight-title';
      title.textContent = interest ? 'À découvrir selon votre visite' : 'À découvrir cette semaine';
      var note = document.createElement('p');
      note.textContent = interest ? 'Un conseil adapté à votre parcours, puis deux idées à explorer.' : 'Trois conseils sélectionnés pour vous inspirer.';
      copy.appendChild(title);
      copy.appendChild(note);
      heading.appendChild(copy);
      section.appendChild(heading);
      var grid = document.createElement('div');
      grid.className = 'lf-guide-directory__spotlight-grid';
      featured.forEach(function (item, index) {
        var link = document.createElement('a');
        link.className = 'lf-guide-directory__spotlight-card';
        link.href = item.url;
        link.dataset.guideHandle = item.handle;
        var img = document.createElement('img');
        img.className = 'lf-guide-directory__thumb';
        img.width = 480;
        img.height = 320;
        img.loading = 'lazy';
        img.alt = '';
        setImage(img, guideImageUrl(item.handle), '');
        var label = document.createElement('span');
        label.className = 'lf-guide-directory__spotlight-copy';
        if (index === 0 && interest) {
          var badge = document.createElement('small');
          badge.textContent = 'Pour vous';
          label.appendChild(badge);
        }
        var name = document.createElement('strong');
        name.textContent = item.title;
        label.appendChild(name);
        link.appendChild(img);
        link.appendChild(label);
        grid.appendChild(link);
      });
      section.appendChild(grid);
      var firstGroup = hub.querySelector('details');
      if (firstGroup) hub.insertBefore(section, firstGroup);
      else hub.appendChild(section);
    }

    function refreshGuideDirectory() {
      var hub = document.querySelector('#MainContent .lf-all-guides, #lf-all-guides');
      if (!hub) return;
      var groups = Array.prototype.slice.call(hub.querySelectorAll('details'));
      groups.forEach(function (group) {
        group.open = false;
        group.classList.add('lf-guide-directory__group');
        var list = group.querySelector('ul');
        if (!list) return;
        list.classList.add('lf-guide-directory__grid');
        list.querySelectorAll('li').forEach(function (item) {
          item.classList.add('lf-guide-directory__hub-item');
          var link = item.querySelector('a');
          if (!link) return;
          link.classList.add('lf-guide-directory__link', 'lf-guide-directory__hub-link');
          var handle = guideHandle(link);
          if (handle) link.dataset.guideHandle = handle;
          var img = link.querySelector('img.lf-guide-directory__thumb');
          if (!img) {
            img = document.createElement('img');
            img.className = 'lf-guide-directory__thumb';
            link.insertBefore(img, link.firstChild);
          }
          setImage(img, guideImageUrl(handle), '');
          img.width = 600;
          img.height = 400;
          img.loading = 'lazy';
          img.setAttribute('aria-hidden', 'true');
        });
      });
      ensureSpotlight(hub, groups);
    }

    function refresh() {
      // Ne jamais remplacer une image éditoriale déjà définie dans le contenu.
      // Les visuels du répertoire sont gérés séparément ci-dessous.
      refreshGuideDirectory();
      document.documentElement.classList.add('lf-guide-media-enhanced');
    }

    refresh();
    var observer = new MutationObserver(function (records) {
      if (records.some(function (record) { return record.addedNodes.length > 0; })) refresh();
    });
    observer.observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', function () { observer.disconnect(); }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
